module.exports = "/images/vendor/flag-icon-css/flags/1x1/bl.svg?4d724b8ec2c508cf9abf4abef61289bc";